/**
 * Phase 66 Plan 02 (D-17) — i18next setup.
 *
 * Italian-only catalogue for Phase 66; EN/ES added later by adding more
 * `locales/*.json` without touching components. Locked `lng: "it"` and
 * `fallbackLng: "it"` per CONTEXT.md D-17.
 *
 * @see RESEARCH.md §Standard Stack — i18n
 */

import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import it from "./locales/it.json";

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: { it: { translation: it } },
    lng: "it",
    fallbackLng: "it",
    interpolation: { escapeValue: false },
    // Detector tries localStorage / navigator; we explicitly lock to IT.
    detection: { order: ["localStorage", "navigator"], caches: ["localStorage"] },
  });

export default i18n;
